import { render, staticRenderFns } from "./PatientScoreView.vue?vue&type=template&id=34bb8d88&scoped=true"
import script from "./PatientScoreView.vue?vue&type=script&lang=js"
export * from "./PatientScoreView.vue?vue&type=script&lang=js"
import style0 from "./PatientScoreView.vue?vue&type=style&index=0&id=34bb8d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bb8d88",
  null
  
)

export default component.exports